import React from "react";

export default function ErrorMessage({ errorMsg, ...restProps }) {
  return (
    <div className="tw-mt-1 tw-text-error-light" {...restProps}>
      {errorMsg}
    </div>
  );
}
